import { useLang } from "@/context/LanguageContext";
import { ASSETS } from "@/i18n";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  const { t } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 bg-[#FAFAFA]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#A78BFA] mb-5" data-testid="faq-eyebrow">
            {t.faq.eyebrow}
          </div>
          <h2
            data-testid="faq-title"
            className="font-serif font-light text-4xl md:text-5xl leading-[1.05] tracking-tight text-[#1A1A1A]"
          >
            {t.faq.title}{" "}
            <span className="italic text-[#737373]">{t.faq.title_accent}</span>
          </h2>
          <div className="mt-10 rounded-3xl overflow-hidden border border-black/5 hidden lg:block">
            <img src={ASSETS.esthetician} alt="esthetician" className="w-full h-auto object-cover" />
          </div>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full" defaultValue="item-0">
            {t.faq.items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-black/10 last:border-b-0"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif text-xl md:text-2xl font-light text-[#1A1A1A] py-6 hover:no-underline"
                >
                  {it.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-base text-[#4A4A4A] leading-relaxed font-light pb-7 pr-6"
                >
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
